<template>
    <div id="permit_type_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
            
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span id="vehiclePermitTypeHeader" class="page-title" v-if="$route.params.id > 0">Update Asset Component</span>
                    <span id="vehiclePermitTypeHeader" class="page-title" v-else>Add Asset Component</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="goPreviousPath" >
                            <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content asset-add-component">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="vehiclePermitTypeForm">
                                <div class="form-row row-cols-md-4 row-cols-1"> 
                                    <div class="col form-group">
                                        <label class="control-label require" for="vehicle_id" >Asset:</label>
                                        <v-select v-model="vehicle_id" name="vehicle_id"
                                            label="text" :filterable="false" :options="vehicleArr"
                                            @search="onSearchVehicle"
                                            placeholder="Select Asset" class="custom-ci-auto-search" v-if="fromView==false">
                                            <template slot="no-options">
                                                Search Asset...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <input type="text" class="form-control" v-model="vehicle_id.text"  placeholder="Select Asset" name="Asset" disabled v-else>
                                        <div class="field-error">{{ vehicle_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                            <!-- <div class="form-group"> -->
                                        <label class="control-label require" for="state">Component:</label>            
                                        <v-select v-model="component" name="component"
                                            label="text" :filterable="false" :options="componentArr"
                                            @search="onSearchComponent"
                                            placeholder="Search Component" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Component...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{component_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="state">Location:</label>            
                                        <v-select v-model="state" name="state"
                                            label="text" :filterable="false" :options="locationArr"
                                            @search="onSearchState"
                                            placeholder="Select Location" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Location...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{state_error_msg}}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require">Install Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="install_date" name="install_date" v-model="install_date" :config="optionsDate" aria-describedby="basic-addon3" class="cal-icon"></date-picker>
                                            <label for="install_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{install_date_error_msg}}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label">Removal Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="removal_date" name="removal_date" v-model="removal_date" :config="optionsDate" aria-describedby="basic-addon3" class="cal-icon"></date-picker>
                                            <label for="removal_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{removal_date_error_msg}}</div>
                                    </div>
                                    <!-- <div class="col-sm-3">
                                        &lt;!&ndash; <div class="form-group"> &ndash;&gt;
                                        <label class="control-label" for="mcp_type">MCP Type:</label>
                                        &lt;!&ndash; <div class="col-sm-12"> &ndash;&gt;
                                        <input type="text" class="form-control" v-model="mcp_type" id="mcp_type" placeholder="Enter MCP Type" name="mcp_type">
                                        <div class="field-error">{{ mcpTypeError }}</div>
                                        &lt;!&ndash; </div> &ndash;&gt;
                                        &lt;!&ndash; </div> &ndash;&gt;
                                    </div>

                                    <div class="col-sm-3">
                                        &lt;!&ndash; <div class="form-group"> &ndash;&gt;
                                        <label class="control-label" for="in_service_distance">In Service Distance:</label>
                                        &lt;!&ndash; <div class="col-sm-12"> &ndash;&gt;
                                        <input type="text" class="form-control" v-model="in_service_distance" id="in_service_distance" placeholder="Enter Service Distance" name="in_service_distance">
                                        <div class="field-error">{{ inServiceDistanceError }}</div>
                                        &lt;!&ndash; </div> &ndash;&gt;
                                        &lt;!&ndash; </div> &ndash;&gt;
                                    </div>-->
                                    <!-- <div class="col form-group">
                                        <label class="control-label">Syn Lube</label>
                                        <div class="custome-radiobtn">
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="syn_lube1">Yes
                                                    <input type="radio" v-model="syn_lube" :value="1" id="syn_lube1" name="syn_lube">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="syn_lube2"> No
                                                    <input type="radio" v-model="syn_lube" :value="0" id="syn_lube2" name="syn_lube">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="field-error"></div>
                                    </div> -->
                                    <!-- <div class="col-sm-3">
                                        <div class="boolean optional vendor_fuel no-h-margin">
                                            <label class="control-label">Out of Sync</label>
                                            <div class="radio-fl-top">
                                                <div class="col-sm-4 radio-btn">
                                                    <div class="row">
                                                        <label class="boolean optional radio-custom" for="out_of_sync1">Yes
                                                            <input type="radio" v-model="out_of_sync" :value="1" id="out_of_sync1" name="out_of_sync">
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="col-sm-4 radio-btn">
                                                    <div class="row">
                                                        <label class="boolean optional radio-custom" for="out_of_sync2"> No
                                                            <input type="radio" v-model="out_of_sync" :value="0" id="out_of_sync2" name="out_of_sync">
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="field-error"></div>
                                    </div>-->
                                </div>
                                <div class="form-row">
                                    <div class="col form-group">
                                        <div class="alert alert-warning hide" id="alertError">
                                            <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                            <strong id="errorMsg" class="field-error"></strong>
                                        </div>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" v-if="$route.params.id > 0" id="createVehiclePermitBtn" class="btn btn-primary" v-on:click.prevent="CreateVehicleComponent" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" v-else id="createVehiclePermitBtn" class="btn btn-primary" v-on:click.prevent="CreateVehicleComponent" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" v-if="$route.params.id == undefined" id="createAndContinueVehiclePermitTypeBtn" class="btn btn-tertiary" v-on:click.prevent="CreateVehicleComponent(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelPermitTypeBtn" class="btn btn-tertiary" v-on:click.prevent="goPreviousPath" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>    
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
export default {
  name: "VehiclePermitTypesCreate",
  metaInfo() {
    return {
        title: (this.$route.params.id > 0)? "Update Asset Component | " +process.env.COPYRIGHT_NAME : "Create Asset Component | " +process.env.COPYRIGHT_NAME
    }
  },
  mixins:[commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    optionsDate: {
        format: 'MM/DD/YYYY',
        useCurrent: false,
    },
    stateArr: [],
    loading:false,
    vehicleArr:[],
    vehicle_id:null,
    install_date:"",
    removal_date:"",
    component_error_msg:"",
    removal_date_error_msg:"",
    install_date_error_msg:"",
    vehicle_error_msg:"",
    componentArr:[],
    component:null,
    state:null,
    locationArr:[],
    permit_type_error_msg:"",
    state_error_msg:"",
    loaded:false,
    unit_no:"",
    syn_lube:"",
      asset_id:0,
      fromView:false,
//      mcp_type:"",
//      mcpTypeError:"",
//      in_service_distance:"",
//      inServiceDistanceError:"",
//      out_of_sync:"",
  }),
  watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_asset_component') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
  },
  created: function() {

  },
  mounted: function() {
    var self = this;
    self.getPermissions();

    var path = window.location.pathname;
    var segments = path.split("/");

    if (segments[3]) {
        self.getAssetComponentData();
    }

      if (self.$route.query.flag == 'fromView') {
          self.asset_id=self.$route.query.asset_id;

          if(self.$route.query.asset_name !="" && self.$route.query.asset_name != undefined && self.asset_id > 0)
          {
              self.vehicle_id = {value: self.asset_id, text: self.$route.query.asset_name};
              self.fromView=true;
          }
      }
  },
  methods: {
      loadVehicle() {
          var path = window.location.pathname;
          var segments = path.split("/");
          var self = this;
          self.loading = true;
          $.ajax({
              url: process.env.ROOT_API + "/search",
              type: "post",
              crossDomain: true,
              headers: this.ajxHeaders,
              data: {
                  search: "",
                  flag:flag,
                  countryId:countryId,
                  stateId:stateId,
                  vendorId:vendorId,
                  parentId:parentId,
                  customerId:customerId,
                  vehicleId:self.asset_id,
                  contractId:contractId,
                  userId:userId,
                  contractWiseAssetId:contractWiseAssetId,
                  model_id:model_id,
                  asset_pool_id:asset_pool_id,
              },
              dataType: "json",
              success: function (data) {

                  if (data.status == "success") {
                      loading(false);
                  }
              },

              error: function (jqXHR, exception) {

                  //self.CheckBtn = 'Check';
                  self.generateStatusCodeMessage(jqXHR,true,'asset-compo-load-vehicle')
              }
          });


      },
    onSearchVehicle(search, loading) {
        var self = this;

        if (search.length > 3) {
            self.searchField(loading, search, 'vehicle');
        }

    },
    onSearchState(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'location', '');
        }
    },
    onSearchComponent(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'component', '');
        }
    },
      BackToList(){
        var self = this;
        setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");

            if (self.fromView==true) {
                self.$router.push({ name: 'AssetView',params:{id:self.vehicle_id.value,viewTab:"componentDetail" }})
            }else{
                self.$router.push("/assetcomponent/list");
            }
        }, 100);
    },
    getAssetComponentData(){
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");
        $.ajax({
            url: process.env.ROOT_API + "/get_asset_component_data/"+segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: 'json',
            success: function (data) {
                self.loading = false;

                if (data.status == 'success') {
                    // self.vehicle_id = {value:data.content.vehicle_id,text:data.content.unit_number},
                    if(data.content.vehicle_id != null){
                        var vehicleData = self.titleCase(data.content.unit_number);
                        if(data.content.vtCode != null){
                            vehicleData += " | " + self.titleCase(data.content.vtCode);
                        }
                        if(data.content.vName != null){
                            vehicleData += " | " + self.titleCase(data.content.vName);
                        }
                        self.vehicle_id = {value: data.content.vehicle_id, text: vehicleData};
                    }else{
                        self.vehicle_id = null;
                    }
                    self.install_date = data.content.install_date;
                    self.removal_date = data.content.removal_date;
                    self.state = {value:data.content.location_id,text:data.content.location};
                    self.component = {value:data.content.component_id,text:data.content.itemName+' ('+data.content.itemCode+')'};
                    self.syn_lube= data.content.syn_lube;
//                    self.mcp_type= data.content.mcp_type;
//                    self.in_service_distance= data.content.in_service_distance;
//                    self.out_of_sync= data.content.out_of_sync;
                }
            },
            error: function (jqXHR, exception) {

                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'asset-compo-get-vehicle')
            }
        });
    },
    CreateVehicleComponent(flag){

        var self = this;
        var error = false;

        self.vehicle_error_msg = "";
        self.install_date_error_msg = "";
        self.removal_date_error_msg = "";
        self.component_error_msg = "";


        if (self.vehicle_id == null || !self.vehicle_id.value || self.vehicle_id == "") {
            self.vehicle_error_msg = "Asset Selection Required.";
            error = true;
        }
        if (self.component == null || !self.component.value || self.component == "") {
            self.component_error_msg = "Component Selection Required.";
            error = true;
        }

        if (!self.install_date || self.install_date == null || self.install_date == "") {
        self.install_date_error_msg = "Install Date Required.";
        error = true;
        }
        if(self.removal_date != null){
           if (Date.parse(self.install_date) > Date.parse(self.removal_date)) {
           self.install_date_error_msg = "Install Date should be earlier than Removal Date";


           error = true;
          }
        }



        if (!error) {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createVehiclePermitBtn").val("Updating ...");
                $("#createVehiclePermitBtn").prop("disabled", true);
                $("#cancelPermitTypeBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueVehiclePermitTypeBtn").val("Saving ...");
                    $("#createVehiclePermitBtn").prop("disabled", true);
                    $("#createAndContinueVehiclePermitTypeBtn").prop("disabled", true);
                    $("#cancelPermitTypeBtn").prop("disabled",true);

                }else{

                    $("#createVehiclePermitBtn").val("Saving ...");
                    $("#createVehiclePermitBtn").prop("disabled", true);
                    $("#createAndContinueVehiclePermitTypeBtn").prop("disabled", true);
                    $("#cancelPermitTypeBtn").prop("disabled",true);
                }

            }

            var fields = $("#vehiclePermitTypeForm").serializeArray();
            fields.push({name: "vehicle_id", value: self.vehicle_id.value});
            if (self.state == null || !self.state.value || self.state == "") {
                fields.push({name: "state_id", value:''});
            }else{
                fields.push({name: "state_id", value: self.state.value});
            }
            fields.push({name: "component", value: self.component.value});


            fields.push({name: "id", value: segments[3]});

            $.ajax({
                url: process.env.ROOT_API + "/assetcomponent/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createVehiclePermitBtn").val("Update");
                        $("#createVehiclePermitBtn").prop("disabled", false);
                        $("#cancelPermitTypeBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueVehiclePermitTypeBtn").val("Save and Continue");
                            $("#createVehiclePermitBtn").prop("disabled", false);
                            $("#createAndContinueVehiclePermitTypeBtn").prop("disabled", false);
                            $("#cancelPermitTypeBtn").prop("disabled",false);

                        }else{

                            $("#createVehiclePermitBtn").val("Save");
                            $("#createVehiclePermitBtn").prop("disabled", false);
                            $("#createAndContinueVehiclePermitTypeBtn").prop("disabled", false);
                            $("#cancelPermitTypeBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#vehiclePermitTypeForm").trigger("reset");
                            self.name ="";
                            self.state = null;
                            self.description = "";
                            self.component = null;
                            self.vehicle_id = null;

                        }else{
                            if(self.fromView==true)
                            {
                                self.$router.push({ name: 'AssetView',params:{id:self.vehicle_id.value,viewTab:"componentDetail" }})
                            }else{
                                self.$router.push("/assetcomponent/list");
                            }

                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createVehiclePermitBtn").val("Update");
                        $("#createVehiclePermitBtn").prop("disabled", false);
                        $("#cancelPermitTypeBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#vehiclePermitTypeForm").trigger("reset");


                            $("#createAndContinueVehiclePermitTypeBtn").val("Save and Continue");
                            $("#createVehiclePermitBtn").prop("disabled", false);
                            $("#createAndContinueVehiclePermitTypeBtn").prop("disabled", false);
                            $("#cancelPermitTypeBtn").prop("disabled",false);

                        }else{

                            $("#createVehiclePermitBtn").val("Save");
                            $("#createVehiclePermitBtn").prop("disabled", false);
                            $("#createAndContinueVehiclePermitTypeBtn").prop("disabled", false);
                            $("#cancelPermitTypeBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'asset-compo-create')
                }
            });
        }else{
            self.errorValidationFocus();
      }
    },
  }
}
</script>




// WEBPACK FOOTER //
// src/components/AssetComponentCreate.vue